import { matchRecent } from './recentGroups';

// Every pickable row in render order: recent activity (filtered by the typed words), then each source's live rows
// and its "See all" link. Arrow keys walk this list; Enter opens the highlighted row.
export function buildOptions({ q, recents, res, sources }) {
  const opts = (recents || []).filter((r) => matchRecent(r, q))
    .map((r) => ({ kind: 'recent', key: `recent-${r.type}-${r.id}`, type: r.type, row: r, path: r.path }));
  if (!q || res.q !== q) return opts;
  sources.forEach((s) => {
    const g = res.groups[s.key];
    if (!g?.items?.length) return;
    g.items.forEach((it) => opts.push({ kind: 'item', key: `item-${s.key}-${it.id}`, type: s.key, row: it, path: it.path }));
    if (g.all) opts.push({ kind: 'all', key: `all-${s.key}`, type: s.key, label: g.all.label, path: g.all.path });
  });
  return opts;
}

export const nextIndex = (cur, n, down) => {
  if (!n) return -1;
  if (down) return cur >= n - 1 ? 0 : cur + 1;
  return cur <= 0 ? n - 1 : cur - 1;
};
